import styled from 'styled-components';
import { mediumBlue } from '../../global-styles';

const H1 = styled.h1`
  font-family: 'Barlow', sans-serif;
  color: ${mediumBlue};
  font-size: 38px;
  letter-spacing: 0.5px;
`;

export default H1;
